import { categoryLinks } from '@/mocks/categories';

export default function CategoryButtons() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          Esplora le nostre categorie
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categoryLinks.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center justify-center gap-3 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden bg-background-50 flex-shrink-0">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <span className="text-xs md:text-sm font-semibold text-foreground-700 group-hover:text-accent-700 whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}